export enum BannedAccountStatus {
  Active = "active",
  Inactive = "inactive"
}

export enum BanType {
  App = "app",
  Session = "session",
  GroupLeader = "group_leader"
}

export type BannedAccount = {
  id: string;
  type: BanType
  groupLeaderId?: string;
  groupSessionId?: string;
  accountId: string;
  firebaseIds: string[];
  ip: string;
  deviceUniqueId: string;
  phoneNumber: string;
  email: string;
  status: BannedAccountStatus;
  dateCreated: string;
  lastUpdated: string;
};